import { Exclude, Expose, plainToInstance, Type } from "class-transformer";
import * as t from "io-ts";
import { SiteEntity, SiteValidator } from "./site";
import { WellEntity, WellValidator } from "./well";
import { Default } from "../util/decorators";

export const TrailerContentsValidator = t.intersection([
  t.type({
    quantity: t.number,
    quantityUom: t.string,
    dttm: t.number
  }),
  t.partial({
    percentFill: t.number,
    maxQuantity: t.number,
    freightType: t.string,
    originSite: SiteValidator,
    originWell: WellValidator,
    destinationSite: SiteValidator
  })
]);

export type TrailerContents = t.TypeOf<typeof TrailerContentsValidator>;

@Exclude()
export class TrailerContentsEntity {
  @Expose()
  quantity!: number;

  @Expose()
  maxQuantity?: number;

  @Expose()
  quantityUom!: string;

  @Expose()
  @Default(0)
  percentFill = 0;

  @Expose()
  freightType?: string;

  @Expose()
  dttm!: number;

  @Expose()
  @Type(() => SiteEntity)
  originSite?: SiteEntity;

  @Expose()
  @Type(() => WellEntity)
  originWell?: WellEntity;

  @Expose()
  @Type(() => SiteEntity)
  destinationSite?: SiteEntity;

  /**
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(trailerContents: TrailerContents): TrailerContentsEntity {
    return plainToInstance(TrailerContentsEntity, trailerContents, {
      excludeExtraneousValues: true
    });
  }
}
